export interface IGroupData {
    Nummer: number
    Navn: string
}

export class Group {
    id = 0

    name = ''

    static build(data: IGroupData): Group {
        const group = new Group()

        group.id = data.Nummer
        group.name = data.Navn

        return group
    }
}

export function mapGroups(data: IGroupData[]): Group[] {
    return data.map((group) => Group.build(group))
}
